import React from 'react';
import Icon from '../../Icon';
import { useNavigate } from 'react-router-dom';
import { remove as removeUser } from '../../../Actions/Person.action';
import { useDispatch } from 'react-redux';
import { breakpoint } from '../../../styling/mixins/breakpoints';
import styled from 'styled-components';
import { cells } from '../../../styling/utils/grid';
import { getColor } from '../../../styling/mixins/colors';
import { text } from '../../../styling/mixins/typography';
import Button from '../../Button';

const StyledUserDesktopItem = styled.li`
  ${cells(5)}
  align-items: center;
  padding: 0 0.8rem;
  gap: 1.6rem;

  &:nth-child(odd) {
    background-color: ${getColor('white')};
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${getColor('grey', 300)};
  }

  .span {
    ${text('large')}
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .btn__wrapper {
    display: flex;
    justify-content: flex-end;

    ${breakpoint('large')} {
      gap: 0.8rem;
    }

    #edit {
      color: ${getColor('gray', 900)};
    }

    #delete {
      color: ${getColor('gray', 900)};
    }
  }
`;

const UserListItemDesktop = ({ person }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <StyledUserDesktopItem className="grid">
      <p className="span">
        {person.firstName} {person.lastName}
      </p>
      <p className="span">{person.email}</p>
      <p className="span">{person.phone}</p>
      <p className="span">{person.role}</p>
      {person.role !== 'Admin' && (
        <div className="btn__wrapper">
          <Button
            btnType="clear"
            btnSize="small"
            onClick={() => navigate(`edit/${person.systemId}`)}
          >
            <Icon
              name="edit"
              id="edit"
              style={{
                width: '24px',
                height: '24px',
              }}
            />
          </Button>
          <Button
            btnType="clear"
            btnSize="small"
            onClick={() => {
              dispatch(removeUser(person.systemId));
            }}
          >
            <Icon
              name="delete"
              id="delete"
              style={{
                width: '24px',
                height: '24px',
              }}
            />
          </Button>
        </div>
      )}
    </StyledUserDesktopItem>
  );
};

export default UserListItemDesktop;
